import React from 'react';
import PropTypes from 'prop-types';

import { Box, Button, Typography } from '@mui/material';
import { HashLink } from 'react-router-hash-link';

export default function DynamicButton({ sx, text, color, hide, noMt }) {
  return (
    <Box
      textAlign="center"
      mt={!noMt && 2}
      mb={(hide && !noMt && 2) || '16px'}
      sx={{
        ...sx,
        zIndex: 1,
        position: 'relative',
      }}
    >
      {/* Top Button */}
      <HashLink smooth to={'/booking#booking_top'}  style={{ textDecoration: 'none' }}>
        <Button
          // component={Link}
          to="/booking"
          // onClick={() => setOpenBookingDialog(true)}
          variant="contained"
          sx={{
            backgroundColor: '#ED2629',
            borderRadius: '10px',
            padding: '12px 24px',
            boxShadow: '0px 8px 10px rgba(0, 0, 0, 0.25)',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#cc0000',
            },
            height: 40,
          }}
        >
          <Typography component="span" color="#FFFFFF">
            <Box className="merri-weather-text-lighter" component="span" sx={{ fontWeight: 100 }}>
              Book A{' '}
            </Box>
            <Box className="merri-weather-text-bold custom-underline" component="span" sx={{}}>
              {text}
            </Box>
          </Typography>
        </Button>
      </HashLink>

      {/* Bottom Line */}
      {!hide && (
        <Box display="flex" justifyContent="center" alignItems="center" mt={0.5} sx={{ color: { color } }}>
          <Typography className="button-text" fontSize={20} component="span" variant="body2" mr={0.5}>
            Expert home visits all over
          </Typography>
          <Box
            component="img"
            src="/assets/images/Home/mobile/dubaiFlag.png"
            alt="UAE Flag"
            sx={{ width: 18, height: 24, mx: 0.5 }}
          />
          <Typography className="button-text" fontSize={20} component="span" variant="body2" ml={0.5}>
            Dubai.
          </Typography>
        </Box>
      )}
    </Box>
  );
}

DynamicButton.propTypes = {
  text: PropTypes.any,
  color: PropTypes.any,
  hide: PropTypes.string,
  noMt: PropTypes.string,
  sx: PropTypes.object,
};
